import React from "react";
import _ from "lodash";

import SweetAlert from "react-bootstrap-sweetalert";
//import { SchemaForm, utils } from "material-ui-schema-form";
import SchemaForm from "react-jsonschema-form";

//material-ui imports
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import Button from "components/CustomButtons/Button.jsx";

//material-ui core
import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";

import Loading from 'views/etc/Loading';

import withStyles from "material-ui/styles/withStyles";
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {createEntryStyle} from "../style";
//import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class AdminCreate extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        const { classes, loading } = this.props;
        return(
            <div>

                <Dialog
                    classes={{
                      root: classes.center,
                      paper: classes.modal
                    }}
                    open={this.props.isOpen}
                    onClose={this.props.onCloseModal}
                    aria-labelledby="create-entry-modal-title"
                    aria-describedby="create-entry-modal-description"
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <DialogTitle 
                        id="create-entry-modal-title"
                        className={classes.modalHeader}
                    >
                        Add Entry
                    </DialogTitle>
                    {(loading) ? <Loading /> :
                    <DialogContent
                        id="create-entry-modal-description"
                        className={classes.modalBody}
                    >
                        <GridContainer>
                            <ItemGrid xs={12} md={12} lg={12}>
                                <SchemaForm 
                                    schema={this.props.schema}
                                    uiSchema={this.props.uiSchema}
                                    onSubmit={this.props.onSubmit}
                                    validate={this.props.validate}
                                    formData={this.props.formData}
                                />
                            </ItemGrid>
                        </GridContainer>
                    </DialogContent>
                    }
                    <DialogActions className={classes.modalFooter}>
                        <Button onClick={this.props.onCloseModal}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>

        )
    }
}

export default withMobileDialog()(withStyles(createEntryStyle)(AdminCreate))


// WEBPACK FOOTER //
// ./src/views/admin/components/AdminCreate.jsx